module.exports = __webpack_public_path__ + "static/media/distribuicao-newmobile.16f45c7b.jpg";